<template>
  <div class="footer">
    <div class="imgs">
      <div class="fl flower-fl">
        &nbsp;<img src="static/images/cactus/cactus4.png" height="30px">
      </div>

      <div class="fr">
        <img src="static/images/cactus/cactus5.png">
        <img src="static/images/cactus/cactus3.png" style="margin-right:-15px;">
      </div>
    </div>
    <p class="allright">
      Acorn by produced
      &nbsp;
      <a target="_blank" href="http://beian.miit.gov.cn"> &nbsp; 粤ICP备20060872号</a>
    </p>
  </div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>

<style>
  .flower-fl{
    bottom:0px;
    position:absolute;
  }
  .allright{
    padding-bottom:5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue